<template>
  <main class="-mt-32" v-if="loaded">
    <div class="px-4 py-10 pb-12 mx-auto -mt-32 max-w-7xl sm:px-6 lg:px-8">
      <div class="overflow-hidden bg-white shadow sm:rounded-md">
        <div class="px-4 py-5 bg-white border-b border-gray-200 sm:px-6">
          <div
            class="flex flex-wrap items-center justify-between -mt-2 -ml-4 sm:flex-no-wrap"
          >
            <div class="mt-2 ml-4">
              <h3 class="text-lg font-medium leading-6 text-gray-900">
                {{ document.number }}
                {{ document.record_id ? records[document.record_id].name : "" }}
              </h3>
            </div>
            <div class="flex-shrink-0 mt-2 ml-4">
              <template v-if="document.id">
                <span class="inline-flex rounded-md shadow-sm">
                  <button
                    @click="destroy"
                    type="button"
                    class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-red-600 border border-transparent rounded-md hover:bg-red-500 focus:outline-none focus:shadow-outline-red focus:border-red-700 active:bg-red-700"
                  >
                    Elimina
                  </button>
                </span>
                <span class="inline-flex rounded-md shadow-sm">
                  <button
                    @click="print"
                    type="button"
                    class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-teal-600 border border-transparent rounded-md hover:bg-teal-500 focus:outline-none focus:shadow-outline-teal focus:border-teal-700 active:bg-teal-700"
                  >
                    Stampa
                  </button>
                </span>
              </template>
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  @click="save"
                  type="button"
                  class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                >
                  Salva
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="px-4 py-4 main-container sm:px-6">
          <div class="h-full">
            <div class="h-full md:grid md:grid-cols-3 md:gap-3">
              <div class="mt-5 scrollable md:mt-0 md:col-span-3">
                <div class="grid grid-cols-6 gap-3">
                  <div class="col-span-6 sm:col-span-2">
                    <label
                      for="type"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Tipo</label
                    >
                    <select
                      id="type"
                      v-model="document.type_id"
                      class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm form-select focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                    >
                      <option
                        v-for="(type, index) in types"
                        :key="index"
                        :value="index"
                      >
                        {{ type }}
                      </option>
                    </select>
                  </div>

                  <div class="col-span-6 sm:col-span-2">
                    <label
                      for="record"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Intestatario</label
                    >
                    <v-select
                      id="record"
                      v-model="document.record_id"
                      :options="Object.values(records)"
                      :reduce="(record) => record.id"
                      label="name"
                      :appendToBody="true"
                      class="block w-full mt-1 transition duration-150 ease-in-out bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                    />
                  </div>

                  <div class="col-span-6 sm:col-span-2">
                    <label
                      for="date"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Data</label
                    >
                    <flat-pickr
                      id="date"
                      v-model="document.date"
                      :config="config"
                      class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                    >
                    </flat-pickr>
                  </div>

                  <fieldset class="col-span-6">
                    <div class="grid grid-cols-6 gap-3">
                      <div class="col-span-6 sm:col-span-2">
                        <div class="absolute flex items-center h-5">
                          <input
                            id="transmission_730"
                            type="checkbox"
                            class="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                            v-model="document.transmission_730"
                          />
                        </div>
                        <div class="text-sm leading-5 pl-7">
                          <label
                            for="transmission_730"
                            class="font-medium text-gray-700"
                            >Trasmissione 730</label
                          >
                        </div>
                      </div>
                      <div class="col-span-6 sm:col-span-2">
                        <div class="absolute flex items-center h-5">
                          <input
                            id="no_ritenuta"
                            type="checkbox"
                            class="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                            v-model="document.no_ritenuta"
                          />
                        </div>
                        <div class="text-sm leading-5 pl-7">
                          <label
                            for="no_ritenuta"
                            class="font-medium text-gray-700"
                            >Ometti ritenuta Acconto</label
                          >
                        </div>
                      </div>
                      <div class="col-span-6 sm:col-span-2">
                        <div class="absolute flex items-center h-5">
                          <input
                            id="vat"
                            type="checkbox"
                            class="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                            v-model="document.iva"
                          />
                        </div>
                        <div class="text-sm leading-5 pl-7">
                          <label for="vat" class="font-medium text-gray-700"
                            >IVA</label
                          >
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div class="col-span-6 mx-auto -mb-3">
                    <button
                      @click="addRow"
                      type="button"
                      class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                    >
                      Aggiungi
                    </button>
                  </div>
                  <div
                    class="col-span-6 overflow-hidden bg-white shadow sm:rounded-md"
                  >
                    <ul>
                      <li v-for="(row, index) in document.rows" :key="index">
                        <div
                          class="block transition duration-150 ease-in-out focus:outline-none"
                        >
                          <div class="flex items-center">
                            <div
                              class="flex-1 min-w-0 sm:flex sm:items-center sm:justify-between"
                            >
                              <div
                                class="flex w-full mt-1 rounded-md shadow-sm"
                              >
                                <button
                                  @click="removeRow(index)"
                                  class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out border border-r-0 border-gray-300 rounded-l-md bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700"
                                >
                                  <svg
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    class="w-5 h-5"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                      clip-rule="evenodd"
                                    ></path>
                                  </svg>
                                </button>
                                <div
                                  class="relative flex-grow focus-within:z-10"
                                >
                                  <input
                                    v-model="row.description"
                                    class="block w-full transition duration-150 ease-in-out border-r-0 rounded-none form-input sm:text-sm sm:leading-5"
                                  />
                                </div>
                                <div class="relative focus-within:z-10">
                                  <div
                                    class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                                  >
                                    <span
                                      class="text-gray-500 sm:text-sm sm:leading-5"
                                    >
                                      &euro;
                                    </span>
                                  </div>
                                  <input
                                    v-model="row.value"
                                    type="number"
                                    class="block w-full text-right transition duration-150 ease-in-out rounded-none form-input rounded-r-md sm:text-sm sm:leading-5"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import { Italian } from "flatpickr/dist/l10n/it";

export default {
  props: {
    id: {
      required: false,
    },
  },

  data: () => {
    return {
      loaded: false,
      config: {
        altFormat: "d/m/Y",
        altInput: true,
        dateFormat: "Y-m-d",
        locale: Italian,
        allowInput: true,
      },
    };
  },

  computed: {
    ...mapState("document", ["document", "types"]),
    ...mapState("record", ["records"]),
    ...mapState("app", ["user"]),
    ordered() {
      this.loaded;
      return _.orderBy(this.records, "name", "asc");
    },
  },

  methods: {
    addRow() {
      this.document.rows.push({});
    },
    removeRow(index) {
      this.document.rows.splice(index, 1);
    },
    save() {
      this.$store.dispatch("document/SAVE", this.document);
    },
    print() {
      this.$store.dispatch("document/PRINT", this.document);
    },
    destroy() {
      if (confirm("Sicuro di voler cancellare il documento?")) {
        this.$store.dispatch("document/DELETE");
      }
    },
  },

  async mounted() {
    await this.$store.dispatch("record/RECORDS");
    this.$store.dispatch("document/RESET");
    if (this.id) {
      await this.$store.dispatch("document/DOCUMENT", { id: this.id });
    } else {
      this.document.type_id = 1;
      this.document.date = moment().format("YYYY-MM-DD");
    }
    this.loaded = true;
  },
};
</script>
